<template>
  <b-row v-if="campaign">
    <b-col cols="12" v-if="campaign.tasks.length">
      <the-header-second-row>
        <header-task-list :id="campaign.id" :tasks="campaign.tasks" />
      </the-header-second-row>
    </b-col>
    <b-col cols="12" md="9">
      <box>
        <bounty-campaign
          :has-link="false"
          :campaign="campaign"
          :show-tasks="false"
        >
          <div
            slot="bottom"
            slot-scope="{ campaign: campaignSlot }"
            v-if="campaignSlot.description"
          >
            <hr />
            <div
              v-html="campaignSlot.description"
              :class="$style.content"
              class="mt-6"
            ></div>
          </div>
        </bounty-campaign>
      </box>
      <box v-if="managerCampaigns.length" class="mb-3">
        <b-form-row class="clearfix align-middle mb-4">
          <b-col cols="9">
            <h2 class="subtitle">
              {{ $t('anotherCampaignsFromManager') }}
              <span class="text-primary">
                {{ managerCampaigns.length }}
                {{ $tc('offer', managerCampaigns.length) }}
              </span>
            </h2>
          </b-col>
          <b-col class="text-right">
            <user-avatar
              v-if="campaign.manager"
              :sho-type="false"
              :name="campaign.manager.name"
              :image="campaign.manager.image"
              :id="campaign.manager.id"
              class="float-right"
            />
          </b-col>
        </b-form-row>

        <b-form-row style="margin-bottom: -10px;">
          <b-col
            cols="6"
            class="campaign-col"
            v-for="campaignItem in managerCampaigns"
            :key="campaignItem.id"
          >
            <bounty-campaign
              :campaign="campaignItem"
              class="box p-4 bounty-campaign--mini"
            >
              <div slot-scope="{ campaign: campaignSlot, statusClass }">
                <header>
                  <div class="labels">
                    <span
                      class="badge"
                      :class="`badge-${statusClass(campaignSlot.status)}`"
                    >
                      {{ $t(`statuses.${campaignSlot.status}`) }}
                    </span>
                    <span
                      v-if="campaignSlot.token"
                      class="badge badge-secondary"
                    >
                      ICO
                    </span>
                  </div>
                  <!-- <div class="add-to-watch-list">
                    <watch-list-add :small="true" />
                  </div> -->
                </header>
                <section>
                  <h1 class="h4">
                    <router-link
                      :to="{
                        name: 'campaign',
                        params: { id: campaignSlot.id }
                      }"
                    >
                      {{ campaignSlot.title }}
                    </router-link>
                  </h1>
                  <span>
                    <dates-range
                      :start="campaignSlot.start"
                      :end="campaignSlot.end"
                      class="small"
                    />
                  </span>
                  <span>
                    <participants
                      :participants="campaignSlot.participants"
                      class="ml-2 small"
                    />
                  </span>
                </section>
              </div>
            </bounty-campaign>
          </b-col>
        </b-form-row>
      </box>
    </b-col>
    <b-col cols="12" md="3">
      <company-information v-if="campaignLinks" :information="campaignLinks" />
      <box class="p-0" v-if="campaign.twitterId">
        <!-- <timeline
          :id="campaign.twitterId"
          source-type="profile"
          :options="{
            tweetLimit: '3'
          }"
        /> -->
      </box>
      <box v-if="campaign.facebookPage" class="p-0">
        <widget-facebook-page :url="campaign.facebookPage" />
      </box>
      <!--
        <box class="p-0" tag="section" v-if="campaign.tasks.length">
          <h3>Bounty List</h3>
          <list-tasks :id="campaign.id" :list="campaign.tasks">
            <sidebar-list-item slot="task" slot-scope="{ task }">
              <router-link :to="`/campaigns/${task.title.toLowerCase().replace(/\s/g, '')}`" class="d-flex align-items-center sidebar-list__item">
                <div class="mr-auto">
                  <svg-icon :icon="`${task.title.toLowerCase().replace(/\s/g, '')}-round`" class="icon-2x" />
                  <span>{{ task.title | capitalize }}</span>
                </div>
                <span class="badge badge-success" v-if="task.percent">{{ task.percent }} %</span>
              </router-link>
            </sidebar-list-item>
          </list-tasks>
        </box>
      -->
    </b-col>
  </b-row>
</template>

<script>
import BountyCampaign from '@/components/BountyCampaign/BountyCampaign.vue';
import WatchListAdd from '@/components/BountyCampaign/WatchListAdd.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import CompanyInformation from './components/CompanyInformation.vue';
import WidgetFacebookPage from '@/components/WidgetFacebookPage.vue';
// import Timeline from 'vue-tweet-embed/timeline';
import ListTasks from '@/components/BountyCampaign/ListTasks.vue';
import SidebarListItem from './components/SidebarListItem.vue';
import HeaderTaskList from './components/HeaderTaskList.vue';
import Participants from '@/components/BountyCampaign/Participants.vue';
import DatesRange from '@/components/DatesRange.vue';
import { mapActions } from 'vuex';

export default {
  head: {
    title() {
      const title = `${this.$t('metaTitle.bountyCampaign')}`;
      return {
        inner: this.campaign ? `${this.campaign.title} ${title}` : title
      };
    }
  },

  components: {
    BountyCampaign,
    WatchListAdd,
    UserAvatar,
    CompanyInformation,
    // Timeline,
    WidgetFacebookPage,
    ListTasks,
    SidebarListItem,
    HeaderTaskList,
    Participants,
    DatesRange
  },

  data() {
    return {
      campaign: null,
      managerCampaigns: []
    };
  },

  computed: {
    touchDevice() {
      return (
        this.$root.screen.xs || this.$root.screen.sm || this.$root.screen.md
      );
    },
    campaignLinks() {
      if (!this.campaign) return [];
      else
        return this.campaign.links.map(el => {
          return {
            title: el.title,
            uri: el.uri,
            icon: el.icon || {
              color: 'text-lighten',
              name: 'link'
            }
          };
        });
    }
  },

  methods: {
    ...mapActions({
      fetchCampaign: 'bounty/fetchCampaign'
    }),
    loadManagerCampaigns() {
      this.$store
        .dispatch('bounty/fetchCampaigns', {
          limit: 100,
          'filter[m][]': this.campaign.manager.id
        })
        .then(
          res => {
            this.managerCampaigns = res.data.list.filter(item => {
              return item.id !== this.campaign.id;
            });
          },
          () => {
            this.managerCampaigns = [];
          }
        );
    }
  },

  watch: {
    campaign() {
      this.$emit('updateHead');
    }
  },

  created() {
    this.fetchCampaign({ id: this.$route.params.id })
      .then(res => {
        this.campaign = res;
        this.loadManagerCampaigns();
      })
      .catch(e => {
        this.$store.commit('SET_PAGE_FAILURE', e);
      });
  }
};
</script>

<style lang="scss" module>
.content {
  h2 {
    margin-bottom: 1.25rem;
  }
}
</style>

<style lang="scss" scoped>
.campaign-col {
  margin-bottom: 10px;
}

h3 {
  text-transform: uppercase;
  font-size: 12px;
  color: $light;
  padding: 1rem;
  border-bottom: 1px solid $border-color;
  margin-bottom: 0;
}
</style>
